/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
type PortfolioFolders_portfoliosConnection$ref = any;
export type FoldersPaginationWrapper_viewer$ref = any;
export type FoldersPaginationWrapper_viewer = {
    readonly portfolios?: {
        readonly totalResults: number | null;
        readonly numberOfPages: number | null;
        readonly pageInfo: {
            readonly hasNextPage: boolean;
            readonly endCursor: string | null;
        };
        readonly edges: ReadonlyArray<{
            readonly cursor: string;
        } | null> | null;
        readonly " $fragmentRefs": PortfolioFolders_portfoliosConnection$ref;
    } | null;
    readonly " $refType": FoldersPaginationWrapper_viewer$ref;
};



const node: ReaderFragment = ({
    "kind": "Fragment",
    "name": "FoldersPaginationWrapper_viewer",
    "type": "Viewer",
    "metadata": {
        "connection": [
            {
                "count": "first",
                "cursor": "after",
                "direction": "forward",
                "path": [
                    "portfolios"
                ]
            }
        ]
    },
    "argumentDefinitions": [
        {
            "kind": "RootArgument",
            "name": "first",
            "type": "Int"
        },
        {
            "kind": "RootArgument",
            "name": "after",
            "type": "String"
        },
        {
            "kind": "RootArgument",
            "name": "portfolioTypes",
            "type": "[PortfolioTypes]"
        },
        {
            "kind": "RootArgument",
            "name": "foldersSort",
            "type": "PortfoliosSortByTypes"
        },
        {
            "kind": "RootArgument",
            "name": "userIds",
            "type": "[String]"
        },
        {
            "kind": "RootArgument",
            "name": "hasUserId",
            "type": "Boolean"
        }
    ],
    "selections": [
        {
            "kind": "Condition",
            "passingValue": true,
            "condition": "hasUserId",
            "selections": [
                {
                    "kind": "LinkedField",
                    "alias": "portfolios",
                    "name": "__FoldersPaginationWrapper_portfolios_connection",
                    "storageKey": null,
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "portfolioTypes",
                            "variableName": "portfolioTypes"
                        },
                        {
                            "kind": "Variable",
                            "name": "sortBy",
                            "variableName": "foldersSort"
                        },
                        {
                            "kind": "Variable",
                            "name": "userIds",
                            "variableName": "userIds"
                        }
                    ],
                    "concreteType": "PortfoliosConnection",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "totalResults",
                            "args": null,
                            "storageKey": null
                        },
                        {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "numberOfPages",
                            "args": null,
                            "storageKey": null
                        },
                        {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "pageInfo",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "PageInfo",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "name": "hasNextPage",
                                    "args": null,
                                    "storageKey": null
                                },
                                {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "name": "endCursor",
                                    "args": null,
                                    "storageKey": null
                                }
                            ]
                        },
                        {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "edges",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "PortfoliosEdge",
                            "plural": true,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "name": "cursor",
                                    "args": null,
                                    "storageKey": null
                                },
                                {
                                    "kind": "LinkedField",
                                    "alias": null,
                                    "name": "node",
                                    "storageKey": null,
                                    "args": null,
                                    "concreteType": "PortfolioV2",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "alias": null,
                                            "name": "__typename",
                                            "args": null,
                                            "storageKey": null
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            "kind": "FragmentSpread",
                            "name": "PortfolioFolders_portfoliosConnection",
                            "args": null
                        }
                    ]
                }
            ]
        }
    ]
} as any);
(node as any).hash = 'bb92d8ea1db1bf9393cc50339d71bec8';
export default node;
